import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* ================================
   THUNK
================================ */
export const updateBusinessUser = createAsyncThunk(
  "businessUser/updateBusinessUser",
  async (
    { userId, formData, currentUser, token },
    { rejectWithValue }
  ) => {
    try {
      const changes = new FormData();

      for (const key in formData) {
        if (key === "username") continue;

        const newValue = formData[key];
        const oldValue = currentUser?.[key];

        // FILE
        if (newValue instanceof File) {
          changes.append(key, newValue);
          continue;
        }

        // SKIP EMPTY
        if (newValue === undefined || newValue === null || newValue === "") {
          continue;
        }

        // DOB FIX
        if (key === "dob") {
          const formattedOld = oldValue ? oldValue.split("T")[0] : "";
          if (newValue !== formattedOld) {
            changes.append(key, newValue);
          }
          continue;
        }

        // NORMAL FIELDS
        if (newValue !== oldValue) {
          changes.append(key, newValue);
        }
      }

      const baseUrl =
        process.env.REACT_APP_BACKEND_BASE_URL ||
        "http://localhost:5000";

      const response = await axios.put(
        `${baseUrl}/business/update/${userId}`,
        changes,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return {
        user: response.data?.user,
        message: response.data?.message,
        updatedCritical: response.data?.updatedCritical || false,
         forceLogout: response.data?.forceLogout,
      };

    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message ||
        err.message ||
        "Update failed."
      );
    }
  }
);

/* ================================
   SLICE
================================ */
const businessUserSlice = createSlice({
  name: "businessUser",
  initialState: {
    data: null,
    loading: false,
    error: null,
    successMessage: null,
    updatedCritical: false,
    forceLogout: false,
  },

  reducers: {
    resetBusinessUserState: (state) => {
      state.successMessage = null;
      state.error = null;
      state.updatedCritical = false;
    },

    clearBusinessUser: (state) => {
      state.data = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ================= LOADING ================= */
      .addCase(updateBusinessUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
        state.updatedCritical = false;
      })

      /* ================= SUCCESS ================= */
      .addCase(updateBusinessUser.fulfilled, (state, action) => {
        state.loading = false;

        // SAFE MERGE
        state.data = action.payload?.user || state.data;

        state.successMessage =
          action.payload?.message || "Profile updated successfully";

        state.updatedCritical =
          action.payload?.updatedCritical || false;
          
            state.forceLogout = action.payload?.forceLogout || false; // ✅ ADD THIS
      })

      /* ================= ERROR ================= */
      .addCase(updateBusinessUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Update failed";
      });
  },
});

export const {
  resetBusinessUserState,
  clearBusinessUser,
} = businessUserSlice.actions;

export default businessUserSlice.reducer;
